/**
 * Give the canvas ownership of touch gestures.
 *
 * Without this the browser owns them: one finger is a scroll, two are a
 * page zoom. It delivers about one pointermove, decides the gesture is
 * its own, and fires pointercancel. Under ?touchUi that reads exactly as
 * the 2026-08-23 LUAT report — a drag that never accumulates ("locked")
 * and a pinch that lands one increment per gesture.
 *
 * Pointer capture is the other half: once a finger is down its moves
 * must keep arriving at the canvas even if it strays over the React
 * overlay, or a drag dies wherever the UI happens to sit.
 */

/**
 * Applies the touch policy and wires pointer capture. Idempotent, and
 * safe on browsers without setPointerCapture — losing capture degrades
 * a drag near the overlay, which is far better than throwing inside a
 * pointerdown handler and killing the gesture outright.
 */
export function applyCanvasTouchPolicy(canvas: HTMLCanvasElement): void {
  canvas.style.touchAction = 'none'
  canvas.style.userSelect = 'none'
  // Safari/older Chromium spelling; harmless where unsupported.
  canvas.style.setProperty('-webkit-user-select', 'none')
  canvas.style.setProperty('-webkit-touch-callout', 'none')

  canvas.addEventListener('pointerdown', (event) => {
    try {
      canvas.setPointerCapture(event.pointerId)
    } catch {
      // No capture available — drags still work over the canvas itself.
    }
  })
}
